import createVueApp from '@/common/createApp'
import sidebar from '@/config/sidebars/jensen'

Styxie.Initializers.JensenCallTrackingWidgets = {
  index: async(props) => {
    const { default: WidgetsIndex } = await import('@/vue_widgets/jensen/call_tracking_widgets/index.vue')
    createVueApp(WidgetsIndex, { props, sidebar })
  },

  new: async(props) => {
    const { default: WidgetsForm } = await import('@/vue_widgets/jensen/call_tracking_widgets/form.vue')
    createVueApp(WidgetsForm, { props, sidebar })
  },

  show: async(props) => {
    const { default: WidgetsShow } = await import('@/vue_widgets/jensen/call_tracking_widgets/show.vue')
    createVueApp(WidgetsShow, { props, sidebar })
  },

  edit: async(props) => {
    const { default: WidgetsForm } = await import('@/vue_widgets/jensen/call_tracking_widgets/form.vue')
    createVueApp(WidgetsForm, { props, sidebar })
  }
}
